import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Card, InputLabel, withStyles, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import swal from '@sweetalert/with-react';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import axiosInstance, { EVENT_ID, WEB_API } from '../constatns';
import queryString from 'query-string';
const styles = (theme) => ({
  cardBox: { minWidth: '700px', padding: '50px 0', marginTop: 30 },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  inputLabel: {
    color: '#777',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  formInput: {
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
    },
  },
  loginInfo: {
    fontSize: '1em',
    lineHeight: 1.7,
    marginTop: 10,
    marginBottom: 40,
    paddingBottom: 20,
    color: '#777',
    borderBottom: '1px solid #ddd',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  },
  submit: {
    fontSize: '1.1em',
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 1),
    },
  },
});

class SponsorLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseNum: '',

      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.refLicenseNum = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
  }

  componentDidMount() {}

  handleSignIn(event) {
    event.preventDefault();
    // eslint-disable-next-line
    const licenseNum = this.state.licenseNum.replace(/ /gi, '').replace(/\-/gi, '');
    const moveTo = queryString.parse(this.props.location.search)['moveTo'] || 'application';

    if (licenseNum.length < 1) {
      swal('사업자등록번호를 입력하세요.').then(() => {
        this.refLicenseNum.current.focus();
      });
      return;
    }
    axiosInstance.get(`${WEB_API}/sponsor/checkNum?eventId=${EVENT_ID}&licenseNum=${licenseNum}`).then((result) => {
      if (result.data.id) {
        this.props.history.push(`/sponsor/${moveTo}?boothId=${result.data.id}&mode=read`);
      } else {
        swal('등록된 사업자정보가 없습니다. 신청 후 확인해주세요.');
      }
    });
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={5} SIdx={1} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <h1>Online Exhibition Application</h1>
            </Grid>
            <Grid item xs={8}>
              <Grid container justifyContent={'center'}>
                <Card className={classes.cardBox} variant="outlined" square>
                  <div style={{ padding: '0 100px' }}>
                    <Typography variant="subtitle1" className={classes.loginInfo}>
                      * 사업자등록번호를 입력하십시오.
                      <br />
                      * 조회가 되지 않는 경우 준비사무국으로 문의하시기 바랍니다.
                      <br />
                      <span style={{ color: 'transparent' }}>* </span>(E-mail: secretariat.kprs@innon.co.kr)
                      <br />
                    </Typography>{' '}
                    <form className={classes.form} noValidate onSubmit={this.handleSignIn}>
                      <Grid container justifyContent="space-between" alignItems="center">
                        <InputLabel htmlFor="email" className={classes.inputLabel}>
                          사업자등록번호
                        </InputLabel>
                        <TextField
                          required
                          size="small"
                          variant="outlined"
                          id="licenseNum"
                          type="text"
                          name="licenseNum"
                          autoFocus
                          onChange={(e) => {
                            this.handleChange('licenseNum', e);
                          }}
                          value={this.state.email}
                          className={classes.formInput}
                          inputRef={this.refLicenseNum}
                          helperText={' - 를 제외하고 입력바랍니다.'}
                        />
                      </Grid>
                      <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        disableElevation
                        className={classes.submit}
                        onClick={this.handleSignIn}
                      >
                        조회하기
                      </Button>
                    </form>
                  </div>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SponsorLogin);
